import React from 'react'

/**
 * FilterSeparator component renders a horizontal line to separate filter sections.
 * @returns {JSX.Element} The rendered separator line.
 */
export const FilterSeparator = () => (
    <hr
        style={{
            borderBottom: '1px solid #0000001A',
            marginBottom: 20,
            marginTop: 20,
        }}
    />
)
